import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaisarshancab() {



const cardData = {
  keyword: " Mumbai Darshan Cabs ",

headingDescription: "Velocity Cab offers comprehensive Mumbai Darshan cabs, providing comfortable and convenient sightseeing tours across the city’s iconic landmarks and cultural hotspots. Our professional drivers, well‑maintained vehicles, and punctual service ensure you enjoy a seamless and memorable exploration of Mumbai’s top attractions. We offer flexible booking options including half‑day tours, full‑day tours, customizable packages, airport pickups, and drop‑offs with transparent pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars suitable for families, groups, and solo travelers. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai Darshan cab services.",

topPlaces: [
  
  {
    title: "Marine Drive",
    description: "Marine Drive is one of Mumbai's most scenic waterfront promenades, offering breathtaking views of the Arabian Sea and the city's skyline. Visitors choosing an Innova Crysta on rent in Pune can enjoy a comfortable road trip before relaxing by the coastline, taking evening walks, and witnessing the famous sunset that makes Marine Drive one of Mumbai's top attractions."
  },
  {
    title: "Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park is a vast green oasis within Mumbai, famous for its wildlife, cycling trails, boating, and lush forests. Booking an Innova Crysta on rent in Pune ensures a comfortable drive to this natural attraction, making it an excellent destination for families, adventure lovers, and nature enthusiasts."
  },
  {
    title: "Hanging Gardens",
    description: "Hanging Gardens on Malabar Hill are beautifully landscaped terraced gardens offering panoramic views of the Arabian Sea and Marine Drive. Travelers choosing an Innova Crysta on rent in Pune can relax amidst well-maintained greenery, unique topiary displays, and peaceful surroundings while enjoying one of Mumbai's most scenic viewpoints."
  },
 
  {
    title: "Flora Fountain",
    description: "Flora Fountain is a magnificent Victorian monument located in the heart of South Mumbai and surrounded by heritage buildings and bustling business districts. Travelers booking an Innova Crysta on rent in Pune can comfortably explore this iconic landmark while visiting nearby shopping streets, cafés, and colonial-era architecture. It is a great destination for history enthusiasts, photographers, and anyone interested in Mumbai's rich heritage."
  },
   {
    title: "Film City, Goregaon",
    description: "Film City in Goregaon is the center of India's entertainment industry and home to numerous Bollywood movie and television sets. Renting an Innova Crysta in Pune makes the journey convenient for families and groups interested in guided studio tours, film sets, and behind-the-scenes experiences of India's vibrant film industry."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is one of Mumbai's most vibrant shopping destinations, offering fashion accessories, handicrafts, antiques, cafés, and street food. Travelers hiring an Innova Crysta on rent in Pune can comfortably explore this lively market while enjoying local shopping and discovering the charm of South Mumbai."
  },
  
  {
    title: "Juhu Beach",
    description: "Juhu Beach is among Mumbai's most popular coastal attractions, known for its lively atmosphere, delicious street food, and spectacular sunsets. Visitors renting an Innova Crysta in Pune can comfortably travel to Mumbai and spend quality time enjoying beach walks, local snacks, and family-friendly entertainment."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is a remarkable meditation monument featuring one of the world's largest stone domes. Travelers booking an Innova Crysta on rent in Pune can enjoy a scenic drive to this peaceful destination near Gorai and experience meditation, spiritual learning, and impressive architecture surrounded by serene landscapes."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a picturesque urban lake surrounded by gardens, restaurants, and modern city landmarks. Hiring an Innova Crysta on rent in Pune provides a smooth journey for families and groups looking to enjoy lakeside views, peaceful walks, boating, and quality leisure time in one of Mumbai's most attractive neighborhoods."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's most iconic historical monument overlooking the Arabian Sea. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this famous landmark, admire its magnificent architecture, enjoy ferry rides to nearby attractions, and capture unforgettable photographs at one of India's most recognized tourist destinations."
  }
],



services: [
{
name: "Mumbai Darshan Cab Service",
description: "Mumbai Darshan cab service offers a complete and comfortable city tour experience covering all major attractions like Gateway of India, Marine Drive, Siddhivinayak Temple, Haji Ali, Juhu Beach, and more. This service is perfect for tourists, families, and corporate visitors who want to explore Mumbai in a single day. Professional drivers with good local knowledge guide travelers through the best routes and sightseeing spots. Air-conditioned vehicles ensure a relaxed journey even during long travel hours. Flexible pickup and drop options are available from hotels, railway stations, and airports. With easy booking and transparent pricing, Mumbai Darshan cab service makes city exploration hassle-free and enjoyable."
},
{
name: "Mumbai Local Sightseeing Cab",
description: "Mumbai local sightseeing cab service provides convenient travel across the city for tourists and residents. Travelers can explore famous landmarks, shopping streets, beaches, and temples with comfortable vehicles and experienced drivers ensuring a smooth city tour."
},
{
name: "Mumbai Darshan Taxi Package",
description: "Mumbai Darshan taxi package offers well-planned itineraries covering top tourist attractions in Mumbai within a day. This package is ideal for visitors who want a structured and comfortable sightseeing experience with fixed pricing."
},
{
name: "One Day Mumbai Darshan Cab",
description: "One day Mumbai Darshan cab service provides a full-day city tour covering major attractions with flexible timing and comfortable travel. It is perfect for tourists with limited time."
},
{
name: "Mumbai City Tour Cab Service",
description: "Mumbai city tour cab service offers guided travel across Mumbai’s iconic landmarks, ensuring a memorable sightseeing experience with professional drivers."
},
{
name: "Mumbai Sightseeing Taxi",
description: "Mumbai sightseeing taxi service provides comfortable and affordable transportation for exploring the city’s top destinations with ease."
},
{
name: "Mumbai Darshan Cab Booking",
description: "Mumbai Darshan cab booking allows travelers to reserve sightseeing cabs easily with instant confirmation and flexible travel schedules."
},
{
name: "Mumbai Darshan Cab Fare",
description: "Mumbai Darshan cab fare provides transparent pricing based on vehicle type and duration, helping travelers plan their sightseeing budget efficiently."
},
{
name: "AC Cab for Mumbai Darshan",
description: "AC cab for Mumbai Darshan ensures comfortable travel in air-conditioned vehicles, ideal for long city tours in all weather conditions."
},
{
name: "Mumbai Tourist Cab Service",
description: "Mumbai tourist cab service offers reliable transportation for visitors exploring Mumbai’s attractions with professional drivers and comfortable vehicles."
},
{
name: "Mumbai Darshan Package by Cab",
description: "Mumbai Darshan package by cab provides a complete sightseeing solution with fixed routes, professional drivers, and comfortable travel arrangements."
},
{
name: "Private Cab for Mumbai Darshan",
description: "Private cab for Mumbai Darshan offers personalized travel experience with flexible itinerary and exclusive vehicle usage for families and groups."
},
{
name: "Cheap Mumbai Darshan Cab",
description: "Cheap Mumbai Darshan cab service provides budget-friendly sightseeing options without compromising comfort and safety."
},
{
name: "Mumbai Darshan Taxi Booking Online",
description: "Mumbai Darshan taxi booking online allows quick and easy reservations with instant confirmation and transparent pricing for hassle-free travel."
},
{
name: "Mumbai City Tour Taxi",
description: "Mumbai city tour taxi service offers convenient transportation for exploring multiple attractions with comfortable vehicles and experienced drivers."
},
{
name: "Full Day Mumbai Darshan Cab",
description: "Full day Mumbai Darshan cab service provides extended sightseeing tours covering all major attractions with comfortable vehicles and flexible schedules for a complete city experience."
}
],

tableData: [
["Mumbai Darshan Cab Service","Mumbai Local Sightseeing Cab"],
["Mumbai Darshan Taxi Package","One Day Mumbai Darshan Cab"],
["Mumbai City Tour Cab Service","Mumbai Sightseeing Taxi"],
["Mumbai Darshan Cab Booking","Mumbai Darshan Cab Fare"],
["AC Cab for Mumbai Darshan","Mumbai Tourist Cab Service"],
["Mumbai Darshan Package by Cab","Private Cab for Mumbai Darshan"],
["Cheap Mumbai Darshan Cab","Mumbai Darshan Taxi Booking Online"],
["Mumbai City Tour Taxi","Full Day Mumbai Darshan Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Complete Mumbai Darshan Packages",
    WhyChoosedescription: "Velocity Cabs offers well-planned Mumbai Darshan cab services covering popular tourist attractions like Gateway of India, Marine Drive, Siddhivinayak Temple, Haji Ali, Juhu Beach, and more in a single trip."
  },
  {
    WhyChooseheading: "Experienced Local Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with Mumbai city routes and tourist locations, ensuring smooth navigation, time-saving routes, and a hassle-free sightseeing experience."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "Velocity Cabs provides budget-friendly Mumbai Darshan packages with transparent pricing. Customers receive complete fare details with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible Sightseeing Plans",
    WhyChoosedescription: "We offer flexible Mumbai Darshan plans including half-day, full-day, and customized sightseeing tours based on your travel needs and preferred locations."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and relaxing city tour experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for families and group tours."
  },
  {
    WhyChooseheading: "Doorstep Pickup & Drop",
    WhyChoosedescription: "We provide convenient pickup and drop from hotels, homes, railway stations, and airports across Mumbai for a seamless sightseeing experience."
  },
  {
    WhyChooseheading: "Trusted Mumbai Tour Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai Darshan cab bookings due to punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "What is included in Mumbai Darshan cab service?", answer: "Mumbai Darshan includes visits to popular tourist places like Gateway of India, Marine Drive, Siddhivinayak Temple, Haji Ali Dargah, Juhu Beach, and other major attractions." },
  { question: "Do you provide full-day Mumbai sightseeing?", answer: "Yes, Velocity Cabs offers full-day as well as half-day Mumbai Darshan packages." },
  { question: "Is Mumbai Darshan cab service available 24 hours?", answer: "Yes, our cab service is available 24/7, but sightseeing packages are generally planned during daytime hours." },
  { question: "Which vehicles are available for Mumbai Darshan?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers for group travel." },
  { question: "Can I customize my Mumbai Darshan itinerary?", answer: "Yes, customers can customize their sightseeing plan based on preferred locations and travel duration." },
  { question: "Do you provide pickup from hotel or airport?", answer: "Yes, we provide doorstep pickup from hotels, homes, railway stations, and airports across Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable city travel." },
  { question: "Can I book Mumbai Darshan cab online?", answer: "Yes, customers can easily book Mumbai Darshan cab services online or through phone booking." },
  { question: "Is driver included in the package?", answer: "Yes, all packages include professional drivers for guided and safe travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Arjun Mehta",
    feedback:
      "Exploring Mumbai with the Darshan cab service was a fantastic experience. The ride was comfortable, the sightseeing plan was well-organized, and everything felt very convenient.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "A great way to cover Mumbai Darshan spots comfortably. The cab was clean, the route was well-planned, and the overall experience felt smooth and enjoyable.",
    rating: 5
  }
];





























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const mumbaiDarshanJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai Darshan Cabs | Velocity Cabs",
  "description": "Book Mumbai Darshan cab services for local sightseeing, one-day city tours, AC cabs, and private taxi packages. Enjoy a hassle-free Mumbai city tour with affordable and reliable cab services.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "touristType": "General",
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "serviceType": [
    "Mumbai Darshan Cab Service",
    "Mumbai Local Sightseeing Cab",
    "Mumbai Darshan Taxi Package",
    "One Day Mumbai Darshan Cab",
    "Mumbai City Tour Cab Service",
    "Mumbai Sightseeing Taxi",
    "Mumbai Darshan Cab Booking",
    "AC Cab for Mumbai Darshan",
    "Private Cab for Mumbai Darshan",
    "Cheap Mumbai Darshan Cab",
    "Full Day Mumbai Darshan Cab"
  ]
};




  return (
    <div>
      
<Helmet>
  <title>Mumbai Darshan Cabs | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book Mumbai Darshan cab services for local sightseeing, one-day city tours, AC cabs, and private taxi packages. Enjoy a hassle-free Mumbai city tour with affordable and reliable cab services."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiDarshanJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/105.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaisarshancab;